import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, MappingState } from '../../../../common/types';

export type SetMappingStateAction = (
	mappingState: MappingState | null,
) => Action<State, void, void>;

export const setMappingState =
	(mappingState: MappingState | null) =>
	({ setState }: StoreActionApi<State>) => {
		setState({ mappingState });
	};
